// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionFooter-module--container--1TZua","headerText":"SectionFooter-module--headerText--3ieeU","textStyle":"SectionFooter-module--textStyle--Qqfgg"};